import { makeStyles } from '@material-ui/core/styles';
import { Autocomplete, Button, Checkbox, Container, FormControl, FormHelperText, Grid, InputLabel, ListItemText, MenuItem, Paper, Select, TextField, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import Swal from 'sweetalert2';
import axios from "../../../utils/axios";

import BackupIcon from '@mui/icons-material/Backup';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

import 'dayjs/locale/en-gb';

import { Box } from "@material-ui/core";
import ReplyIcon from '@mui/icons-material/Reply';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';



const options = [{ tradecode: "No Data Available", name: "" }];

const useStyles = makeStyles((theme) => ({
  modalContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    height: '80%',
    backgroundColor: 'white',
    padding: '20px',
    overflow: 'auto',
  },
}));

const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '60%',
        height:"80vh",
        bgcolor: 'background.paper',
        border: '2px solid #eee',
        boxShadow: '2px 2px 2px 2px #eee',
        borderRadius:"10px",
        p: 4
      };

const ForwardingLetterUpload = () => {
  const [issuerData, setIssuerData] = useState({});
  const [issuerValue, setIssuerValue] = useState("")
  const [key, setKey] = useState(Date.now());
  const [thisCompanysYearType, setThisCompanysYearType] = useState([]);
  const [yearTypeAvailable, setYearTypeAvailable] = useState('');
  const [yearShow, setYearShow] = useState([]);

  const classes = useStyles();
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [isPaymentSelected, setIsPaymentSelected] = useState(false);


  let currentDate = new Date().toJSON().slice(0, 10);
  const [handleFromLimit, setHandleFromLimit] = useState(new Date().toJSON().slice(0, 10));
  let minimumFromDate = new Date(handleFromLimit).toJSON().slice(0, 10);

  const [data, setData] = useState({
    issuerId: issuerValue,
    dividendType: "",
    dividendYear: "",
    issuerSentOnDate: null,
    cmsfReceivedOnDate: "",
    docketingNo: "",
    cashAmount: "",
    stockAmount: "",
    netAmount:0.0,
    companyOthersId:"",
    refNo:"",
    subject:"",
    note:""
  });

 const [pdfFile, setPdfFile] = useState(null); 
  const fileInputRef = useRef(null);
 const isDisabled = !data.issuerId || !data.dividendType || !data.dividendYear || !data.issuerSentOnDate || !data.netAmount || !pdfFile || !data.docketingNo ;
  
  useEffect(() => {
    axios.get('./issuer/get-info')
      .then((res) => {
        setIssuerData(res.data.payload);
      })
      .catch((err) => {
        alert(err.response.data.message);
      });

    if (data.issuerId !== '') {
      axios.get(`/issuer-year-format/${data.issuerId}`)
        .then((res) => {
          setThisCompanysYearType(res.data.payload);
          if (res?.data?.payload?.length === 0) {
            setYearTypeAvailable('false');
            setData({ ...data, dividendYear: [] });
          } else {
            setYearTypeAvailable('true');
            setData({ ...data, dividendYear: [] });
          }
        })
        .catch((err) => {
          alert(err.response.data.message);
        });
    }
  }, [data.issuerId]);

  const handleYearChange = (event, newValue) => {
    setYearShow(event.target.value);
    setData({ ...data, dividendYear: event.target.value });
  };

  const handleNumberChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handlePdfChange = (e) => {
    const file = e.target.files[0];
                  
            if(file && file.type === "application/pdf"){
                      if ( file.type === "application/pdf" ) 
                        {
                          if((file.size/1024)>1024)
                              {
                                Swal.fire({
                                  icon: 'warning',
                                  title: 'The File is greater than 1 MB! ',
                                  text:"Please upload a file smaller than 1 MB.",
                                  showConfirmButton: true,
                                  customClass: {
                                      container: 'my-swal'
                                    },
                                  // timer: 3000
                                })
                                return;
                              }
                              else{
                                  setPdfFile(file);  
                                  setOpen(true);
                              }
                    }      
                  }
                
                  else
                  {
                    Swal.fire({
                      icon: 'warning',
                      title: 'File does not support. You must use .pdf ',
                      showConfirmButton: true,
                      customClass: {
                          container: 'my-swal'
                        },
                      // timer: 3000
                    })
                    return;
                  }
                  
                  e.target.value = null; 
                };                                                                                    

  // const handlePdfChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file && file.type === 'application/pdf') {
  //     const url = URL.createObjectURL(file);
  //     setPdfUrl(url);
  //     setSelectedPdf(file);
  //     setOpenModal(true); // Open modal when a PDF is selected
  //   } else {
  //     alert('Please upload a valid PDF file.');
  //   }
  // };

  const handleClose = () => {
    setOpenModal(false);
    setPdfUrl(null); // Reset the PDF URL when the modal is closed
  };

  const handleReset = () => {

    setKey(Date.now());
    setData({
      issuerId: issuerValue,
      dividendType: '',
      dividendYear: [],
      issuerSentOnDate: '',
      cmsfReceivedOnDate: '',
      fewLetter: '',
      netAmount: 0.0,
      docketingNo: '',
      companyOthersId: '',
      refNo: '',
      subject: '',
      note: ''
    });
      
    setPdfFile(null);  // Clear the state that holds the file
    if (fileInputRef.current) {
      fileInputRef.current.value = '';  // Reset the file input element
    }
  };

  const handleSubmit = async (e) => {
    const formData = new FormData();

    formData.append('issuerId', data.issuerId);
    formData.append('dividendType', data.dividendType);
    formData.append('dividendYear', JSON.stringify(data.dividendYear)); // Assuming this is an array
    formData.append('issuerSentOnDate', data.issuerSentOnDate);
    formData.append('cmsfReceivedOnDate', data.cmsfReceivedOnDate);
    //formData.append('cashAmount', data.cashAmount);
    formData.append('stockAmount', data.stockAmount);
    formData.append('netAmount', data.netAmount);
    formData.append('docketingNo', data.docketingNo);
    formData.append('companyOthersId', data.companyOthersId);
    formData.append('refNo', data.refNo);
    formData.append('subject', data.subject);
    formData.append('note', data.note);
    
    if (pdfFile) {
      formData.append('images', pdfFile);
    }

    try {
      const response = await axios.post('inward-dividend/create-forward-letter-info', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      Swal.fire({
        title: response.data.payload.fn_create_forwarding_letter_upload,
        icon: "success",
      }); 
      setIssuerValue("")
      handleReset()
    } 
    
    catch (err) {
      console.error('Error:', err);
      Swal.fire({
        title: "Something went wrong! Please try again after fixing the issue",
        text: `Issue: ${err.response ? err.response.data.message : 'Unknown error'}`,
        icon: "error",
        confirmButtonText: 'Ok',
      });
    } 
  };
  const handleOpenPreview = () =>{
      return(
        <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={()=>{setOpen(false);} }
        closeAfterTransition
        BackdropComponent={Backdrop}
        slots={{ backdrop: Backdrop }}
        slotProps={{
        backdrop: {
            timeout: 500,
        }}}
       style={{overflow: "auto", display:"flex",justifyContent:"center",alignItems:"center", textAlign:"center", borderRadius:"10px"
       }}
       >
        <Fade in={open}>
        <Box sx={style} style={{textAlign:"center",width:"80%",height:"80vh"}} >
            <h3>PDF PREVIEWER </h3>
            <Box className="form-control" style={{textAlign:"center",height:"90%"}}>
                {pdfFile ? (
                    // <div
                    //     style={{
                    //         border: '1px solid rgba(0, 0, 0, 0.3)',
                    //         height: '100%',
                    //     }}
                    // >
                    //     <Viewer fileUrl={fileURL} />
                    // </div>
                    <iframe
                        src={pdfFile ? URL.createObjectURL(pdfFile) : ''}
                        width="100%"
                        height="100%"
                        title="PDF Viewer"
                      />
                ) : (
                    <div
                        style={{
                            alignItems: 'center',
                            border: '2px dashed rgba(0, 0, 0, .3)',
                            display: 'flex',
                            fontSize: '2rem',
                            height: '100%',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        Please upload a PDF file to preview.
                    </div>
                )}
                
                <Button type="button" onClick={()=>{setOpen(false);}} variant="contained" color="info" style={{color:"white"}}><ReplyIcon/> Close</Button>
                </Box>
        </Box>
        </Fade>
    </Modal>
      )

      
    }

 
  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ padding: 4,  borderRadius: 2,boxShadow:"2px 2px 2px 2px gray"  }}>
        <Typography variant="h5" align="center" gutterBottom>
          <strong>Informations of the Incoming Letter</strong>
        </Typography>

        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <FormControl fullWidth>
              <Autocomplete
              key={key}
              value={data.name}
              label="Select Issuer"
              size="small"
              onChange={(event, newValue) => {
                setIssuerValue( newValue.id);
                setData({ ...data, issuerId: newValue.id });
              }}
              
              disableClearable
              options={issuerData ? issuerData : options}
              getOptionLabel={(option) => option.name + " (" + option.tradecode + ")"}
              renderInput={(params) => <TextField {...params} required label="Select Issuer Name" />}
              />
            </FormControl>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextField
                        label="Subject"
                          variant="outlined"
                          fullWidth
                          value={data.subject}
                          onChange={(e) => setData({ ...data, subject: e.target.value })}
                          placeholder="Enter Subject"
                          size="small"
                      />
        </Grid>

          <Grid item lg={4} md={4} sm={12} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel id="dividend-year-label">Dividend Year</InputLabel>
              <Select
                required
                labelId="dividend-year-label"
                id="dividend-year-select"
                multiple
                
                value={data.dividendYear}
                onChange={(e, newValue) => handleYearChange(e, newValue)}
                renderValue={(selected) => selected.map((item) => item.year).join(', ')}
                label="Dividend Year"
                
              >
                {thisCompanysYearType.map((i) => (
                  <MenuItem key={i.id} value={i}>
                    <Checkbox checked={yearShow.indexOf(i) > -1} />
                    <ListItemText primary={i.year} />
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>Add New Year: <a href="/app/issuer/yearDefine">define year</a></FormHelperText>
            </FormControl>
          </Grid>

          <Grid item lg={4} md={4} sm={12} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel id="dividend-type-label">Dividend Type</InputLabel>
              <Select
                required
                labelId="dividend-type-label"
                id="dividend-type-select"
                value={data.dividendType}
                onChange={(e) => setData({ ...data, dividendType: e.target.value })}
                label="Dividend Type"
              >
                <MenuItem value="Cash">Cash</MenuItem>
                <MenuItem value="Stock">Stock</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <TextField
              required
              size="small"
              label="Docketing Number"
              variant="outlined"
              fullWidth
              value={data.docketingNo}
              onChange={(e) => setData({ ...data, docketingNo: e.target.value })}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={12} xs={12}>
            <TextField
              required={data.dividendType}
              disabled={!data.dividendType}
              size="small"
              label={data.dividendType==='Cash' ? "Cash Amount": data.dividendType==='Stock' ? "Stock Share" : "Enter Dividend Type First"}
              type="number"
              variant="outlined"
              fullWidth
              value={data.netAmount}
              onChange={handleNumberChange}
              onWheel={(e) => e.target.blur()}           // Disable mouse wheel
                  
                    onKeyDown={(e) => {
                      if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                        e.preventDefault();                    // Disable arrow keys
                      }
                    }}
              //name="cashAmount"
              name="netAmount"
              
            />
          </Grid>

          {/* {data.dividendType === 'Stock' &&<Grid item lg={4} md={4} sm={12} xs={12}>
            <TextField
              required={data.dividendType==='Stock'}
              label="Stock share"
              type="number"
              size="small"
              variant="outlined"
              fullWidth
              value={data.stockAmount}
              onChange={handleNumberChange}
              onWheel={(e) => e.target.blur()}           // Disable mouse wheel
                  
                    onKeyDown={(e) => {
                      if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                        e.preventDefault();                    // Disable arrow keys
                      }
                    }}
              //name="stockAmount"
              name="netAmount"
            />
          </Grid>} */}

          <Grid item lg={4} md={4} sm={12} xs={12}>
            <TextField
            required
              label="Incoming Letter Recieved Date"
              size="small"
              type="date"
              variant="outlined"
              min={Date.now()}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                max: `${currentDate && data.cmsfReceivedOnDate}`,
                }}
              value={data.issuerSentOnDate}
              onChange={(e) => 
                {
                      if(e.target.value > currentDate)
                      {
                        Swal.fire({
                          icon: 'error',
                          title: 'Please select a valid date today\'s date or before.',
                          text: 'The Forwarding Letter Recieved Date cannot be in the future.',
                        });
                        e.target.value = ""; // Reset the input value
                        setData({ ...data, issuerSentOnDate: e.target.value })
                        return;
                      }
                      else{
                        setData({ ...data, issuerSentOnDate: e.target.value })
                      }
                }
              }
            />
          </Grid>

          <Grid item lg={4} md={4} sm={12} xs={12}>
            <TextField
              label="Bank / BO Received Date"
              size="small"
              type="date"
              variant="outlined"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              // inputProps={{
              //   max: `${currentDate}`,
              //   min: `${data.issuerSentOnDate}`
              //   }}
              value={data.cmsfReceivedOnDate}
              onChange={(e) => {
                if(!data.issuerSentOnDate)
                {
                  Swal.fire({
                    icon: 'warning',
                    title: 'Please Select Forwarding Letter Recieved Date First',
                    text: 'You must select the Forwarding Letter Recieved Date before selecting the Bank Payment Receive Date.',
                    
                  });
                  return;
                }
                else{
                setData({ ...data, cmsfReceivedOnDate: e.target.value })
                }
                

              }}
            />
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
                      <TextField
                        label="Reference Number"
                        size="small"
                          variant="outlined"
                          fullWidth
                          value={data.refNo}
                          onChange={(e) => {
                                      setData({ ...data, refNo: e.target.value })
                                    }}
                          placeholder="Enter Reference Number"
                      />
                    </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
            <TextField
              label="Note"
              variant="outlined"
              fullWidth
              value={data.note}
              onChange={(e) => setData({ ...data, note: e.target.value })}
                size="small"
            />
          </Grid>
      
           {/* File Upload */}
           <Grid item lg={12} md={12} sm={12} xs={12}>
  {/* <TextField
    id="file-upload"
    label="Upload PDF"
    type="file"
    variant="outlined"
    fullWidth
    onChange={handlePdfChange}
    InputLabelProps={{
      shrink: true, // Ensure the label is always visible
    }}
    inputProps={{ accept: "application/pdf" }}
  /> */}
    {/* <TextField
        required
        id="file-upload"
        label="Upload PDF"
        type="file"
        inputRef={fileInputRef}
        variant="outlined"
        fullWidth
        onChange={handlePdfChange}
        InputLabelProps={{
          shrink: true, // Ensure the label is always visible
        }}
        inputProps={{ accept: 'application/pdf' }}
      /> */}
      {/* <div style={{textAlign:"center",border:"1px solid gray", padding:"10px", borderRadius:"10px"}}>
        <h4 style={{color:"slateblue",marginBottom:"10px"}}>Documents Upload (Maximum Limit 1 MB) : </h4>
                      <Grid container spacing={2} style={{justifyContent:"center",alignItems:"center"}}>
                      <Grid item lg={6} md={6} sm={12} xs={12} for="pdfupload"  > <label
                                        for="pdfupload"
                                        style={{ color: "black", border:"1px solid slateblue" }}
                                        className="btn btn-warning btn-lg"
                                        ><BackupIcon style={{fill:'black'}} /> Upload PDF File</label>
                                        <input
                                          id="pdfupload"
                                          name="folio_bo_file"
                                          type="file"
                                          accept="application/pdf"
                                          onChange={handlePdfChange}
                                          style={{ display: "none",visibility:"none" }}
                                        />
                                        {pdfFile ? 
                                        <>
                                        <button className="btn btn-danger btn-lg" type="button" style={{color:"white", border:"2px solid white", marginLeft:"2px"}}
                                        onClick={()=>{
                                          Swal.fire({
                                            icon: 'question',
                                            title: 'Are you sure about removing the file selected?',
                                            showConfirmButton: true,
                                            confirmButtonText: 'Yes',
                                            showCancelButton: true,
                                            cancelButtonText: "No",
                                            customClass: {
                                                container: 'my-swal'
                                              },
                                          }).then((res)=>{
                                            if(res.isConfirmed)
                                            {
                                              setPdfFile("");
                                            }
                                          })
                                        }}
                                        >X</button>
                                        <h6>{pdfFile?.name}</h6> 
                                        <h6>{Math.round(pdfFile?.size/1024)} KB </h6> 
                                        
                                        </>
                                        : null}
                                        </Grid>
                                        {open && handleOpenPreview()}
                                  <Grid item lg={6} md={6} sm={12} xs={12} >
                                  
                                    <button className="btn btn-primary btn-lg" type="button" style={{color:"white",border:"1px solid white"}} onClick={()=>{setOpen(true);}}><RemoveRedEyeIcon/> Preview Uploaded PDF</button>
                                          {open && handleOpenPreview()}
                                  </Grid>
                                        </Grid>
    </div> */}

    <div
  onDragOver={(e) => e.preventDefault()}
  onDrop={(e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
   if(file && file.type === "application/pdf"){
                      if ( file.type === "application/pdf" ) 
                        {
                          if((file.size/1024)>1024)
                              {
                                Swal.fire({
                                  icon: 'warning',
                                  title: 'The File is greater than 1 MB! ',
                                  text:"Please upload a file smaller than 1 MB.",
                                  showConfirmButton: true,
                                  customClass: {
                                      container: 'my-swal'
                                    },
                                  // timer: 3000
                                })
                                return;
                              }
                              else{
                                  setPdfFile(file);  
                                  setOpen(true);
                              }
                    }      
                  }
                
                  else
                  {
                    Swal.fire({
                      icon: 'warning',
                      title: 'File does not support. You must use .pdf ',
                      showConfirmButton: true,
                      customClass: {
                          container: 'my-swal'
                        },
                      // timer: 3000
                    })
                    return;
                  }
  }}
  style={{
    border: "2px dashed slateblue",
    padding: "20px",
    borderRadius: "10px",
    textAlign: "center",
    backgroundColor: "#f5f5f5",
  }}
>
  <h4 style={{ color: "slateblue", marginBottom: "10px" }}>
    Documents Upload (Maximum Limit 1 MB) :
  </h4>
  <p style={{color:"slateblue"}}> Drag and Drop / Select PDF by clicking the button</p>
<Grid container spacing={2} style={{justifyContent:"center",alignItems:"center"}}>
                      <Grid item lg={6} md={6} sm={12} xs={12} for="pdfupload"  > 
  <label htmlFor="pdfupload" className="btn btn-warning btn-lg" style={{ border: "1px solid slateblue" }}>
    <BackupIcon style={{ fill: "black" }} /> Upload PDF File
  </label>

  <input
    id="pdfupload"
    name="folio_bo_file"
    type="file"
    accept="application/pdf"
    onChange={handlePdfChange}
    style={{ display: "none" }}
  />

  {pdfFile && (
    <>
      <button
        className="btn btn-danger btn-lg"
        type="button"
        style={{ marginLeft: "10px" }}
        onClick={() => {
          Swal.fire({
            icon: "question",
            title: "Remove the selected file?",
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
          }).then((res) => {
            if (res.isConfirmed) setPdfFile("");
          });
        }}
      >
        X
      </button>
      <h6>{pdfFile?.name}</h6>
      <h6>{Math.round(pdfFile?.size / 1024)} KB</h6>
    </>
  )}
 </Grid>
 <Grid item lg={6} md={6} sm={12} xs={12} >
                                  
  {/* <div style={{ marginTop: "15px" }}> */}
    <button
      className="btn btn-primary btn-lg"
      type="button"
      style={{ color: "white", border: "1px solid white" }}
      onClick={() => setOpen(true)}
    >
      <RemoveRedEyeIcon /> Preview Uploaded PDF
    </button>
  {/* </div> */}
 </Grid>
  </Grid>
  {open && handleOpenPreview()}
</div>


      

      {/* Modal to display PDF 
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="pdf-modal-title"
        aria-describedby="pdf-modal-description"
      >
        <Box className={classes.modalContent}>
          <Button onClick={handleClose} variant="contained" color="secondary">
            Close
          </Button>
          {pdfUrl && (
            <div style={{ marginTop: '20px' }}>
              <Document file={pdfUrl}>
                <Page pageNumber={1} />
              </Document>
            </div>
          )}
        </Box>
      </Modal>*/}
      <Grid item xs={12} style={{textAlign:"center",margin:"20px 0"}}>
          <p style={{color:"#0d6efd",fontWeight:"bold",fontSize:"15px"}}>Note: please fill all the mandatory fields to submit</p>
          </Grid>
</Grid>

          
          <Grid item xs={12}>
            <Button variant="contained" color="primary" fullWidth
            disabled={isDisabled}
            onClick={(e)=>handleSubmit(e)}>
              Submit
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default ForwardingLetterUpload;

